<template>
  <v-main class="fill-height pa-0">
    <v-row align="center" align-content="center">
      <v-col cols="12" sm="3">
        <v-select
          v-model="filter.bin"
          :items="$store.getters['admin/bins']"
          :label="$t('fields.bin')"
          item-value="bin"
          item-text="name"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" sm="3">
        <v-select
          v-model="filter.tag"
          :items="$store.getters['admin/webpostags']"
          :label="$t('fields.tags')"
          clearable
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="webposusers"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      class="transparent add-relative-position"
      show-expand
      item-key="idx"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab bottom absolute @click="edit({ status: 1 })" dark class="pink ml-4">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{item, headers}">
        <td :colspan="headers.length">
          <v-row>
            <v-col v-for="k in details" :key="k.value">
              <div class="subtitle-2">{{k.text}}</div>
              <div>{{format(item, k.value)}}</div>
            </v-col>
          </v-row>
        </td>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <v-btn icon @click="edit(item)">
            <v-icon color="primary">mdi-eye</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.status="{ item }">
        <v-icon
          :color="item.status==1?'success':'error'"
        >{{item.status==1?"mdi-check":"mdi-cancel" }}</v-icon>
      </template>
      <template
        v-slot:item.terminal="{ item }"
      >{{ $store.getters["admin/terminal"](item.terminal).description }}</template>
      <template
        v-slot:item.server="{ item }"
      >{{$store.getters["admin/lss"]($store.getters["admin/terminal"](item.terminal).lss).name}}</template>
      <template v-slot:item.domen="{ item }">{{ $store.getters["admin/bin"](item.bin).domen }}</template>
      <template v-slot:item.ip="{ item }">
        <span class="ip-data-cell">{{ item.ip }}</span>
      </template>
      <template v-slot:item.rules.ekk="{ item }">
        <v-icon>{{ (item.rules && item.rules.noekk) ?'':'mdi-check' }}</v-icon>
      </template>
      <template v-slot:item.rules.vcard="{ item }">
        <v-icon>{{ (item.rules && item.rules.novcard) ?'':'mdi-check' }}</v-icon>
      </template>
      <template v-slot:item.rules.download="{ item }">
        <v-icon>{{ (item.rules && item.rules.nodownload) ?'':'mdi-check' }}</v-icon>
      </template>
      <template v-slot:item.ip="{ item }">{{ item.ip?item.ip.split(",").length:"0" }}</template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <i18n path="admin.webposuser">
            <template #idx>{{ item.idx }}</template>
          </i18n>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit = false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.name"
              :error-messages="user_errors"
              :label="$t('fields.name')"
              :rules="[(v) => !!v || $t('error.required')]"
            ></v-text-field>
            <v-select
              v-model="item.bin"
              :items="$store.getters['admin/bins']"
              attach
              chips
              item-text="name"
              item-value="bin"
              :rules="[(v) => v.length>0 || $t('error.required')]"
              :label="$t('fields.bin')"
            ></v-select>
            <v-row class="mx-1" justify="space-between">
              <v-checkbox v-model="isekk" :label="$t('fields.isEkk')" class="mr-2"></v-checkbox>
              <v-checkbox v-model="isvcard" :label="$t('fields.isVcard')" class="mr-2"></v-checkbox>
              <v-checkbox v-model="isdownload" :label="$t('fields.isDownload')"></v-checkbox>
            </v-row>
            <v-row v-if="item.rules && item.rules['Remote-Identity']">
              <v-col>
                <i18n path="fields.remid" />:
                <span class="subtitle-2">{{item.rules["Remote-Identity"]}}</span>
                <v-btn icon @click.prevent="$api.cleanRemoteIdentity(item.idx)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-select v-model="item.status" :items="$t('statuses')" :label="$t('fields.status')"></v-select>
            <!-- <v-text-field
              v-model="item.domen"
              :label="$t('fields.domen')"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-text-field>-->
            <TagsEditor v-model="item.tags" />
            <v-text-field v-model="item.tags" :label="$t('fields.tags')"></v-text-field>
            <v-text-field
              v-model="item.ip"
              :label="$t('fields.ip')"
              :rules="[(v) => !!v || $t('error.required')]"
            ></v-text-field>
            <v-select
              v-model="item.terminal"
              :items="$store.getters['admin/terminals']"
              item-text="description"
              item-value="idx"
              :label="$t('fields.terminal')"
            ></v-select>
            <!-- <v-text-field
              v-model="item.bin"
              :label="$t('fields.bin')"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-text-field>-->
            <div>
              <v-icon v-if="token" @click="getTokenInfo">mdi-information</v-icon>
              <v-icon v-if="token" @click="getTokenCopy">mdi-content-copy</v-icon>
              <div id="tokendiv" class="py-1">{{ token }}</div>
              <div>{{ tokenInfo }}</div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="d_confirm = true" color="primary">{{ $t("button.delete") }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="generateToken" color="primary">{{ $t("button.token") }}</v-btn>
          <v-btn text @click="checkSettings" color="primary">{{ $t("button.check") }}</v-btn>
          <v-btn text @click="update" color="primary">{{ $t("button.update") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="d_confirm"
      :mode="dmode"
      @click:ok="remove"
    >{{ $t("dialog.txt.delWebPosuser") }}</ConfirmDialog>
  </v-main>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import TagsEditor from "../TagsEditor.vue";

export default {
  components: { TagsEditor },
  name: "AdminWebPosUsers",
  mixins: [commonmixin],
  data() {
    return {
      user_errors: "",
      d_edit: false,
      token: "",
      tokenInfo: "",
      filter: {
        bin: null,
        tag: null,
      },
      item: {},
      details: [
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.updated"), value: "updated", align: "center" },
        { text: this.$t("fields.ip"), value: "ip", align: "center" },
        { text: this.$t("fields.remid"), value: "remid", align: "center" },
      ],
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          width: 100,
          divider: true,
        },
        {
          text: this.$t("fields.name"),
          value: "name",
          divider: true,
        },
        { text: this.$t("fields.lss"), value: "server", sortable: false },
        {
          text: this.$t("fields.terminal"),
          value: "terminal",
          divider: true,
        },
        {
          text: this.$t("fields.domen"),
          value: "domen",
          sortable: false,
        },
        {
          text: this.$t("fields.bin"),
          value: "bin",
          filter: (value) => {
            if (!this.filter.bin) return true;
            return value == this.filter.bin;
          },
        },
        {
          text: this.$t("fields.isEkk"),
          value: "rules.ekk",
          sortable: false,
        },
        {
          text: this.$t("fields.isVcard"),
          value: "rules.vcard",
          sortable: false,
        },
        {
          text: this.$t("fields.isDownload"),
          value: "rules.download",
          sortable: false,
          divider: true,
        },
        {
          text: this.$t("fields.status"),
          value: "status",
        },
        {
          text: this.$t("fields.ip"),
          value: "ip",
          align: "center",
          divider: true,
          sortable: false,
        },
        {
          text: this.$t("fields.tags"),
          value: "tags",
          filter: (value) => {
            return (
              !this.filter.tag ||
              (value && value.indexOf(this.filter.tag) != -1)
            );
          },
        },
      ],
    };
  },
  computed: {
    webposusers() {
      return this.$store.getters["admin/webposusers"];
    },
    isekk: {
      get() {
        return (
          !this.item.rules ||
          this.item.rules.noekk == undefined ||
          !this.item.rules.noekk
        );
      },
      set(v) {
        if (!this.item.rules) this.item.rules = {};
        this.item.rules.noekk = !v;
      },
    },
    isvcard: {
      get() {
        return (
          !this.item.rules ||
          this.item.rules.novcard == undefined ||
          !this.item.rules.novcard
        );
      },
      set(v) {
        if (!this.item.rules) this.item.rules = {};
        this.item.rules.novcard = !v;
      },
    },
    isdownload: {
      get() {
        return (
          !this.item.rules ||
          this.item.rules.nodownload == undefined ||
          !this.item.rules.nodownload
        );
      },
      set(v) {
        if (!this.item.rules) this.item.rules = {};
        this.item.rules.nodownload = !v;
      },
    },
  },
  methods: {
    format(i, k) {
      try {
        if (k == "created" || k == "updated" || k == "lastUsed")
          return this.$options.filters["dt-time"](i[k]);
        if (k == "remid" && i.rules) return i.rules["Remote-Identity"];
        return i[k];
      } catch (error) {
        return error;
      }
    },
    checkSettings() {
      this.$api.wpuCheckSettings(this.item.idx).then((r) => {
        this.$root.$emit("showmsg", { msg: r });
        console.log(JSON.stringify(r));
      });
    },
    getTokenInfo() {
      this.$api.getTokenInfo({ token: this.token }).then((r) => {
        if (r.token) {
          this.tokenInfo = JSON.stringify(r);
        } else {
          this.tokenInfo = r;
        }
      });
    },
    getTokenCopy() {
      this.$api.copyText("tokendiv");
    },
    generateToken() {
      this.$api.getToken(this.item.idx).then((r) => {
        if (r.token) {
          this.token = r.token;
        } else {
          this.token = r;
        }
      });
    },
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      //if (this.item.bin) this.item.bin = this.item.bin.split(",");
      this.currentIdx = this.webposusers.indexOf(i);
    },
    remove() {
      this.$store.dispatch("admin/DELETE_WEBPOSUSER", this.item);
      this.d_edit = false;
      // this.$api.deleteWebPosUser(this.item.idx).then((r) => {
      //   if (r) {
      //     this.items.splice(this.currentIdx, 1);
      //   }
      //   this.d_edit = false;
      // });
    },
    update() {
      if (!this.$refs.form.validate()) return;
      //if (this.item.bin) this.item.bin = this.item.bin.join(",");
      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_WEBPOSUSER", {
            item: this.item,
            index: this.currentIdx,
          })
          .then(() => {
            this.d_edit = false;
          });
        // this.$api.updateWebPosUser(this.item).then((r) => {
        //   if (r) {
        //     Object.assign(this.items[this.currentIdx], this.item);
        //   }
        //   this.d_edit = false;
        // });
      } else {
        const prev = this.webposusers.find((e) => {
          return e.name == this.item.name;
        });
        if (prev) {
          this.user_errors = this.$t("error.dublicate");
        } else {
          this.$store
            .dispatch("admin/INSERT_WEBPOSUSER", this.item)
            .then((response) => {
              if (response == 0) {
                this.user_errors = this.$t("error.api");
              } else {
                this.d_edit = false;
              }
            });
          // this.$api.insertWebPosUser(this.item).then((r) => {
          //   if (r) {
          //     this.items.push({ ...this.item, idx: r });
          //   } else {
          //     this.user_errors = this.$t("error.api");
          //   }
          //   this.d_edit = false;
          // });
        }
      }
    },
  },
  mounted() {
    if (!this.$store.getters["admin/isWebPosUsers"]) {
      this.$store.dispatch("admin/LOAD_WEBPOSUSERS");
    }
    // this.$api.getWebPosUsers().then((r) => {
    //   this.items = r;
    // });
    if (!this.$store.getters["admin/isTerminals"]) {
      this.$store.dispatch("admin/LOAD_TERMINALS");
    }
    if (!this.$store.getters["admin/isLss"]) {
      this.$store.dispatch("admin/LOAD_LSS");
    }
    if (!this.$store.getters["admin/isBins"]) {
      this.$store.dispatch("admin/LOAD_BINS");
    }
  },
};
</script>

<style>
.add-relative-position {
  position: relative;
}
</style>